module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container table-data"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "school_name",
      "placeholder": "请输入学校",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'schoolsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('schoolsList', 2)
      },
      "select": function (item) { return _vm.handleSelect(item, 'schoolsList'); }
    },
    model: {
      value: (_vm.autocompleteData.school_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "school_name", $$v)
      },
      expression: "autocompleteData.school_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店名称",
      "prop": "shopCode"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "shop_name",
      "placeholder": "请输入门店",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'shopsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('shopsList')
      },
      "select": function (item) { return _vm.handleSelect(item, 'shopsList'); }
    },
    model: {
      value: (_vm.autocompleteData.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "shop_name", $$v)
      },
      expression: "autocompleteData.shop_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "goodCode"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "gdName",
      "placeholder": "请输入商品",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'goodsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('goodsList')
      },
      "select": function (item) { return _vm.handleSelect(item, 'goodsList'); }
    },
    model: {
      value: (_vm.autocompleteData.good_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "good_name", $$v)
      },
      expression: "autocompleteData.good_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, _vm._l((_vm.tableColumn), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.id,
        "label": item.name,
        "show-overflow-tooltip": true,
        "width": item.width,
        "fixed": item.fixed
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.formatter) ? _c('span', [_vm._v(_vm._s(item.formatter(scope.row)))]) : _c('span', [_vm._v(_vm._s(scope.row[item.id]))])]
        }
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1df2de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/headOffice/goods/list.vue
// module id = 880
// module chunks = 0